// function setAdHeight() {
//     setTimeout(() =>{
//       if (window.innerWidth >= 900) {
//         var imageL = window.innerWidth >= 900 ? document.querySelector(".ads--large img") : document.querySelector(".ads--large .mobile img");
//         if (imageL != null || imageL != undefined) {
//           var imageheight = imageL.clientHeight;
//         }
//         var imageS = window.innerWidth >= 900 ? document.querySelector(".ads--small img") : document.querySelector(".ads--small .mobile img");
//         if (imageS != null || imageS != undefined) {
//           var imageheightS = imageS.clientHeight;
//         }
//         var ads = document.querySelectorAll(".ads--large")
//         if (ads.length >= 1) {
//           ads.forEach(ad => {
//             ad.style.height = imageheight + 'px';
//           });
//         }
//         var adsS = document.querySelectorAll(".ads--small");
//         if (adsS.length >= 1) {
//           adsS.forEach(ad => {
//             ad.style.height = imageheightS + 'px';
//           });
//         }
//       }
//     }, 500);
//   }
const getOffsets = (container) => {
    const threeArticles = container.querySelectorAll('.three-article-section');
    const twoArticles = container.querySelectorAll('.two-article-section');
    const articles = container.querySelectorAll('.one-article-section');
    const settingsElement = document.querySelector('div[data-article-settings]');
    
    let settings = JSON.parse(settingsElement.dataset.articleSettings);

    return {
        threeArticles: { "offset": (threeArticles.length * settings.threeArticles.max) + 1 , "max": settings.threeArticles.max },
        twoArticles: { "offset": (twoArticles.length * settings.twoArticles.max) + 1 , "max": settings.twoArticles.max },
        article: { "offset": (articles.length * settings.article.max) + 1, "max": settings.article.max }
    }
};

const fetchArticles = (container, btn) => {
    container.classList.add('loading');

    fetch('/loadarticles/'+ JSON.stringify(getOffsets(container))).then((response) => {
        return response.text();
    }).then(text => {
        // Convert the HTML string into a document object
        let parser = new DOMParser();
        let doc = parser.parseFromString(text, 'text/html');

        let hasArticle = doc.querySelectorAll('.article').length > 0;
        if(!hasArticle){
          btn.remove();
          return;
        }
        
        let ads = doc.querySelectorAll('.ads');

        // ads.forEach((el) => {
        //     window.initSlider(el);
        // });

        for(let i = 0; i < doc.body.children.length; i++){
            container.appendChild(doc.body.children[i]);
        }

        container.classList.remove('loading');
    });
};

document.addEventListener('DOMContentLoaded', () => {
    const btn = document.querySelector('#load-more-articles');

    if(btn){
        const container = document.querySelector('#articles-container');

        btn.addEventListener('click', () => {
            fetchArticles(container, btn);
            // setAdHeight();
        });
    }
    
})
